import debug from "debug";
import plugin from '../../lib/plugin';

const MODULE_NAME = 'app.core/modules/pop-window';
const log = debug(MODULE_NAME);

const ELEMENT_SELECTOR = '[data-pop-window]';

function clickHandler (event) {
    log('click');

	//	Ensure script does not interfere with modifier clicks
	if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey ) {
        log('Modifier key detected. Aborting window pop');
		return true;
    }

    event.preventDefault();

    const parameters = `menubar=${this.options.menubar},height=${this.options.height},width=${this.options.width},toolbar=${this.options.toolbar},scrollbars=${this.options.scrollbars},status=${this.options.status},resizable=${this.options.resizable}`;

    log(parameters);

    this.windows[this.options.popname] = window.open(this.element.href, this.options.popname, parameters);
    this.windows[this.options.popname].focus();
}

class PopWindow {
    constructor(element, options) {
        this.element = element;
        this.options = options;
        this.$element = $(element);
        log('PopWindow', element, options);
        this.watch();
    }

    watch() {
        if (!this.element.href) {
            log('Anchor has no href. Aborting...', this.element);
            return false;
        }
        this.$element.on('click.popwindow', clickHandler.bind(this));
    }

    unwatch() {
        this.$element.off('.popwindow');
        log('unbound', this.element);
    }
}

PopWindow.DEFAULTS = {
    height: 400, // sets the height in pixels of the window.
    width: 500, // sets the width in pixels of the window.
    toolbar: 1, // determines whether a toolbar (includes the forward and back buttons) is displayed {1 (YES) or 0 (NO)}.
    menubar: 1, // determines whether the menubar is displayed {1 (YES) or 0 (NO)}.
    scrollbars: 1, // determines whether scrollbars appear on the window {1 (YES) or 0 (NO)}.
    status: 0, // whether a status line appears at the bottom of the window {1 (YES) or 0 (NO)}.
    resizable: 1, // whether the window can be resized {1 (YES) or 0 (NO)}. Can also be overloaded using resizable.
    popname: 'pop'
};

PopWindow.windows = {};

plugin('popWindow', PopWindow);

export function exec() {
    $(document).ready(() => {
        log('binding');
        $(ELEMENT_SELECTOR).popWindow();
        log('bound');
    });
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/pop-window/index.js